// extracted by mini-css-extract-plugin
export default {"root":"ExtendedSearchCard_root__xaUS+","card":"ExtendedSearchCard_card__daZF9","cardContent":"ExtendedSearchCard_cardContent__gk8kS","image":"ExtendedSearchCard_image__05Lwf"};